import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { UnarchiveOutlined } from '@mui/icons-material';

export const RestoreButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<UnarchiveOutlined />} {...props}>
      {children ?? t('Restore')}
    </Button>
  );
};
